import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6344f78d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { class: "register1-detail" }
const _hoisted_3 = { class: "item text-overflow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "账户名称：", -1))
const _hoisted_5 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户行名称：", -1))
const _hoisted_7 = { class: "item text-overflow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "账号：", -1))
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户日期：", -1))
const _hoisted_11 = {
  class: "item text-overflow",
  style: {"width":"500px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 基本存款账户编号（开户许可证可查）：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "客户经理姓名：", -1))
const _hoisted_16 = { class: "item text-overflow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "客户经理电话/柜台电话：", -1))
const _hoisted_18 = { class: "register-table" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import { getBankAccountRegistration } from "@/api/process_bank";
import Image from "@/components/Image.vue";
import RisTable from "@/components/Table.vue";

import type {} from "@/types/procss";

export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }



watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getBankAccountRegistrationDetail();
    }
  }
);
// const uploadList = ref([]);
const AccountName = ref<string>("");
const BankName = ref<string>("");
const AccountNumber = ref<string>("");
const OpeningDate = ref<string>("");
const DepositAccountNumber = ref<string>("");
const AccountManagerName = ref<string>("");
const AccountManagerPhone = ref<string>("");
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

const getBankAccountRegistrationDetail = async () => {
  const { Data } = await getBankAccountRegistration({
    BranchCompanyFlowId: props.folwId,
  });
  if (Data?.PageData) {
    // uploadList.value = Data?.PageFiles || [];
    AccountName.value = Data?.PageData.AccountName || "";
    BankName.value = Data?.PageData.BankName || "";
    AccountNumber.value = Data?.PageData.AccountNumber || "";
    OpeningDate.value = Data?.PageData.OpeningDate || "";
    DepositAccountNumber.value = Data?.PageData.DepositAccountNumber || "";
    AccountManagerName.value = Data?.PageData.AccountManagerName || "";
    AccountManagerPhone.value = Data?.PageData.AccountManagerPhone || "";
    tableData.value = Data?.PageFiles || [];
  }
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

onMounted(async () => {
  getBankAccountRegistrationDetail();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(AccountName.value), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(BankName.value), 1)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(AccountNumber.value), 1)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(OpeningDate.value.split(" ")[0]), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(DepositAccountNumber.value), 1)
      ]),
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(AccountManagerName.value), 1)
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", null, _toDisplayString(AccountManagerPhone.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
    ])
  ]))
}
}

})